import {apiAction, dataAction, silentApiAction} from "actions/actionWrappers";
import {addCallSlot, bookSuggestedCall, fetchCallSlots, fetchSuggestedCallTimes, removeCallSlot} from "api/callSlotsApi";
import {loadEvents} from "actions/eventsAction";
import {actions} from "reducers/mentorshipReducer";

const loadCallSlots = mentorshipId => async dispatch => {
  const callSlots = await dispatch(silentApiAction(fetchCallSlots, mentorshipId));
  dispatch(dataAction(actions.STORE_CALL_SLOTS, callSlots));
};

const loadSuggestedCallTimes = mentorshipId => async dispatch => {
  const suggested = await dispatch(silentApiAction(fetchSuggestedCallTimes, mentorshipId));
  dispatch(dataAction(actions.STORE_SUGGESTED_CALL_TIMES, suggested));
};

// The short list drives the suggested dates, so both refresh after an edit.
const refreshCallSlots = mentorshipId => async dispatch => {
  await Promise.all([dispatch(loadCallSlots(mentorshipId)), dispatch(loadSuggestedCallTimes(mentorshipId))]);
};

const addSlot = (mentorshipId, slot) => async dispatch => {
  await dispatch(apiAction(addCallSlot, mentorshipId, slot));
  await dispatch(refreshCallSlots(mentorshipId));
};

const removeSlot = (mentorshipId, slotId) => async dispatch => {
  await dispatch(apiAction(removeCallSlot, mentorshipId, slotId));
  await dispatch(refreshCallSlots(mentorshipId));
};

const bookCall = (mentorshipId, event) => async dispatch => {
  await dispatch(apiAction(bookSuggestedCall, mentorshipId, event));
  await Promise.all([dispatch(loadEvents(mentorshipId)), dispatch(loadSuggestedCallTimes(mentorshipId))]);
};

export {
  bookCall,
  refreshCallSlots,
  addSlot,
  removeSlot,
};
